<h2>{{formLabels['title']}} {{form1.value.name}}</h2>
<form [formGroup]="form1">
  <mat-tab-group>
    <mat-tab label="Message Manager">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="block">
              <mat-card>
                <div class="row">
                  <div class="col-12">
                    <mat-card-header>
                      <mat-card-title>Message Manager</mat-card-title>
                    </mat-card-header>
                  </div>
                  <div class="col-12">
                    <mat-card-content>
                      <div class="row">
                        <div class="col-12">
                          @if (('form1.value.messageId')) {
                            <mat-form-field class="block"> <input matInput placeholder="MessageId" [value]="form1.value.messageId" readonly="true"> </mat-form-field>
                          }
                        </div>
                        <div class="col-12">
                          @if (('form1.value.confirmationId')) {
                            <mat-form-field class="block"> <input matInput placeholder="ConfirmationId" [value]="form1.value.confirmationId" readonly="true"> </mat-form-field>
                          }
                        </div>
                        <div class="col-12">
                          @if (('form1.value.messageStatus')) {
                            <mat-form-field class="block"> <input matInput placeholder="Status" [value]="form1.value.messageStatus" readonly="true"> </mat-form-field>
                          }
                        </div>
                        <div class="col-12">
                          @if (('form1.value.createDate')) {
                            <mat-form-field class="block"> <input matInput placeholder="Created" [value]="form1.value.createDate" readonly="true"> </mat-form-field>
                          }
                        </div>
                        <div class="col-12">
                          @if (('form1.value.sendDate')) {
                            <mat-form-field class="block"> <input matInput placeholder="Sent" [value]="form1.value.sendDate" readonly="true"> </mat-form-field>
                          }
                        </div>
                        <div class="col-12">
                          @if (('form1.value.receiveDate')) {
                            <mat-form-field class="block"> <input matInput placeholder="Received" [value]="form1.value.receiveDate" readonly="true"> </mat-form-field>
                          }
                        </div>
                        <div class="col-12">
                          <mat-form-field class="block">
                            <input matInput placeholder="opsNotes" formControlName="opsNotes" readonly="{{formReadOnly}}">
                            @for (validation of validationMessages.opsNotes; track validation) {
                              <mat-error>
                                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                                  <mat-error class="error-message">
                                  {{validation.opsNotes}}</mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                    </mat-card-content>
                  </div>
                </div>
              </mat-card>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="block">
              <mat-card>
                <div class="row">
                  <div class="col-lg-12">
                    <mat-card-header>
                      <mat-card-title>Contact</mat-card-title>
                    </mat-card-header>
                  </div>
                  <div class="col-lg-12">
                    <mat-card-content>
                      <div class="row">
                        <div class="col-lg-12">
                          <mat-form-field class="block">
                            <input matInput placeholder="First Name" formControlName="toFirstName" readonly="{{formReadOnly}}">
                            @for (validation of validationMessages.toFirstName; track validation) {
                              <mat-error>
                                @if (form1.get('toFirstName').hasError(validation.type) && (form1.get('toFirstName').dirty || form1.get('toFirstName').touched)) {
                                  <mat-error class="error-message">
                                  {{validation.toFirstName}}</mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-lg-12">
                          <mat-form-field class="block">
                            <input matInput placeholder="Last Name" formControlName="toLastName" readonly="{{formReadOnly}}">
                            @for (validation of validationMessages.toLastName; track validation) {
                              <mat-error>
                                @if (form1.get('toLastName').hasError(validation.type) && (form1.get('toLastName').dirty || form1.get('toLastName').touched)) {
                                  <mat-error class="error-message">
                                  {{validation.toLastName}}</mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <br />
                        <div class="col-lg-12">
                          <mat-form-field class="block">
                            <mat-select #messageTemplateSelect placeholder="Template" [(value)]="form1.value.messageTemplateId" formControlName="messageTemplate"
                              (selectionChange)="onMessageTemplateSelect($event)">
                              @for ( order of orders; track  order) {
                                <mat-option [value]="order.messageTemplateId"> {{order.name}} </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="col-lg-12">
                          <mat-form-field class="block">
                            <textarea matInput placeholder="Message" formControlName="message" readonly="{{formReadOnly}}" matTextareaAutosize matAutosizeMinRows=10 matAutosizeMaxRows=500
                            required></textarea>
                            @for (validation of validationMessages.message; track validation) {
                              <mat-error>
                                @if (form1.get('message').hasError(validation.type) && (form1.get('message').dirty || form1.get('message').touched)) {
                                  <mat-error class="error-message">
                                  {{validation.message}}</mat-error>
                                }
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                    </mat-card-content>
                  </div>
                </div>
              </mat-card>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="block">
              <mat-card>
                <div class="row">
                  <div class="col-lg-12">
                    <mat-card-header>
                      <mat-card-title>Email</mat-card-title>
                    </mat-card-header>
                  </div>
                  <div class="col-lg-12">
                    <mat-card-content>
                      <mat-checkbox formControlName="sendByText" class="block"> Send Text:&nbsp;&nbsp; </mat-checkbox>
                      <mat-form-field class="block">
                        <input matInput placeholder="Mobile Phone" formControlName="toPhoneNumber" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.toPhoneNumber; track validation) {
                          <mat-error>
                            @if (form1.get('toPhoneNumber').hasError(validation.type) && (form1.get('toPhoneNumber').dirty || form1.get('toPhoneNumber').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.toPhoneNumber}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field class="block">
                        <mat-select placeholder="Country Code" [(value)]="form1.value.toPhoneCountryCode" formControlName="toPhoneCountryCode">
                          @for ( code of toPhoneCountryCodeArray; track  code) {
                            <mat-option [value]="code.value"> {{code.name}} </mat-option>
                          }
                        </mat-select>
                        @for (validation of validationMessages.toPhoneCountryCode; track validation) {
                          <mat-error>
                            @if (form1.get('toPhoneCountryCode').hasError(validation.type) && (form1.get('toPhoneCountryCode').dirty || form1.get('toPhoneCountryCode').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.toPhoneCountryCode}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </mat-card-content>
                  </div>
                </div>
              </mat-card>
            </div>
            <div class="block">
              <mat-card>
                <div class="row">
                  <div class="col-lg-12">
                    <mat-card-header>
                      <mat-card-title>Email</mat-card-title>
                    </mat-card-header>
                  </div>
                  <div class="col-lg-12">
                    <mat-card-content>
                      <mat-checkbox formControlName="sendByEmail" class="block"> Send Email:&nbsp;&nbsp; </mat-checkbox>
                      <mat-form-field class="block">
                        <input matInput placeholder="Email" formControlName="toEmailAddress" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.toEmailAddress; track validation) {
                          <mat-error>
                            @if (form1.get('toEmailAddress').hasError(validation.type) && (form1.get('toEmailAddress').dirty || form1.get('toEmailAddress').touched)) {
                              <mat-error class="error-message"
                                >
                              {{validation.toEmailAddress}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                      <mat-form-field class="block">
                        <input matInput placeholder="toSubject" formControlName="toSubject" readonly="{{formReadOnly}}">
                        @for (validation of validationMessages.toSubject; track validation) {
                          <mat-error>
                            @if (form1.get('toSubject').hasError(validation.type) && (form1.get('toSubject').dirty || form1.get('toSubject').touched)) {
                              <mat-error class="error-message">
                              {{validation.toSubject}}</mat-error>
                            }
                          </mat-error>
                        }
                      </mat-form-field>
                    </mat-card-content>
                  </div>
                </div>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="History">
      <app-audit-list [auditUrl]="'messages/' + this.messageId + '/audit'"></app-audit-list>
    </mat-tab>
  </mat-tab-group>
  @if (formAction.includes('add')) {
    <button mat-raised-button color="primary" (click)="formAdd()" [disabled]="!form1.valid">Send</button>
  }
  @if (formAction.includes('add')) {
    <button mat-button type="reset" (click)="this.form1.reset()">Clear</button>
  }
  @if (formAction.includes('add')) {
    <button mat-button type="button" (click)="routerLocation.back()">Cancel</button>
  }

  @if (formAction.includes('edit')) {
    <button mat-raised-button color="primary" (click)="formUpdate()" [disabled]="!form1.valid">Update</button>
  }
  @if (formAction.includes('edit')) {
    <button mat-button type="button" [routerLink]="['/message-view', form1.value.messageId]">Cancel</button>
  }

  @if (formAction.includes('view')) {
    <button mat-raised-button color="primary" [routerLink]="['/message-edit', form1.value.messageId]">Edit</button>
  }
  @if (formAction.includes('view')) {
    <button mat-button type="button" [routerLink]="['/message-list']">Done</button>
  }
  @if (formLoading) {
    <img class="pl-3"
		src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
</form>
